
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stock/[ticker]",
      function () {
        return require("private-next-pages/stock/[ticker]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stock/[ticker]"])
      });
    }
  